//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Specialists',
  emits: ['close'],
  props: {
    content: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    activeCategory: {
      type: String,
      reuqired: false,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      isShow: true,
      specialistsCounter: 3,
    }
  },
  computed: {
    getSpecialistsCounter() {
      if (this.activeCategory === '4') {
        return this.content.length;
      }
      return this.specialistsCounter;
    }
  },
};
